import { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';
import { Box, CssBaseline } from "@mui/material"
import { useGlobalState } from "../global/context/global-context";
import { PropsWithChildren, useEffect } from "react";
import { useGlobalController } from "../global/context/global-controller";
import React from "react";
import DefaultBackdrop from "../components/default-backdrop";
import { useBaseLayoutState } from "./context/base-layout-context";
import DefaultMessage from "../components/default-message";
import DefaultDialog from "../components/default-dialog";
import * as locales from '@mui/material/locale';
import axios, { AxiosError } from 'axios';
import { useBaseLayoutController } from './context/base-layout-controller';


// const mdTheme = createTheme();


export const BaseLayout: React.FC<PropsWithChildren> = (props) => {
    const { applicationData } = useGlobalState();
    const { dialogProps, messageProps, backdropPros } = useBaseLayoutState();
    const { getApplicationData } = useGlobalController();
    const { showDialog, showBackDrop, showMessage, handlerErrorShowMessage } = useBaseLayoutController();

    const theme = useTheme();

    const themeWithLocale = createTheme(theme, locales["ptBR"]);

    axios.interceptors.response.use((response: any) => {
        return response;
    }, function (error: AxiosError) {
        handlerErrorShowMessage(error);
    });

    useEffect(() => {


        if (applicationData === undefined) {
            getApplicationData();
        }
    }, []);

    // const loadingComponent = (<Grid container height={"100vh"} sx={{ position: 'relative', display: 'inline-flex', backgroundColor: "lihqhtgray" }}
    //     spacing={0}
    //     direction="column"
    //     alignItems="center"
    //     justifyContent="center"
    // >
    //     <CircularProgress color="primary" />
    //     <Typography sx={{ pt: 2 }}>carregando...</Typography>

    // </Grid>);

    return (
        <ThemeProvider theme={themeWithLocale}>
            <React.Fragment>


                <Box sx={{ display: 'flex' }}>
                    <CssBaseline />
                    <DefaultBackdrop {...backdropPros}></DefaultBackdrop>
                    <DefaultMessage {...messageProps}></DefaultMessage>
                    <DefaultDialog {...dialogProps}></DefaultDialog>
                    <React.Fragment>


                        {props.children}
                    </React.Fragment>
                </Box>

            </React.Fragment>
        </ThemeProvider>
    );
};

